


























// @ts-nocheck
import { Component, Vue, Watch } from 'vue-property-decorator'
import Editor from '@/components/Editor.vue'
import { RowConfig } from '@/lib/RowConfig.interface'
import { copyFromDataStore } from '@/amplify'
import { mutateSnackbar } from '@/store/snackbar'
import { query as tenant } from '@/store/tenant'
import { DataStore, Hub } from 'aws-amplify'
import { Info } from '../models/index'
import { HubEvents } from '@/amplify'

@Component<DistrictInfoEditView>({
  components: {
    Editor
  },
  // @ts-ignore
  metaInfo() {
    return {
      title: this.$t('infoEdit.title')
    }
  },
  apollo: {
    tenant
  }
})
export default class DistrictInfoEditView extends Vue {
  info = null
  isLoading = false
  isPreviewVisible = false

  get editorRows(): RowConfig[] {
    return [
      { title: this.$t('infoEdit.contentTitle'), type: 'title', key: 'title' },
      { title: this.$t('infoEdit.content'), type: 'text', key: 'content' }
    ]
  }

  get infoId() {
    return this.$route.params.infoId
  }

  @Watch('infoId', { immediate: true })
  refetchInfo() {
    this.getInfo()
  }

  async getInfo() {
    this.isLoading = true
    try {
      const query = await DataStore.query(Info, this.infoId)
      if (!query) throw new Error('InfoPage not found')
      this.info = copyFromDataStore(query)
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
    this.isLoading = false
  }

  async saveInfo() {
    this.isLoading = true
    try {
      await DataStore.save(
        Info.copyOf(
          await DataStore.query(Info, this.infoId),
          updated => {
            for (const [key, value] of Object.entries(this.info)) {
              updated[key] = value
            }
            updated["districtID"] = this.info.districtInfosId
          }
        )
      )
      mutateSnackbar(
        { text: String(`Erfolgreich gespeichert`), color: `success` },
        this.$apollo
      )
      Hub.dispatch('ListEdit', {
        event: HubEvents.itemUpdate,
        data: {
          model: 'Info',
        }
      })
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
    this.isLoading = false
  }
}
